export default __webpack_public_path__ + "media/images/celeste_home-73da91fd17bfbb183d1fbdc54b7c8731.png";